import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Login page component - automatically redirects to Keycloak SSO
 */
const Login = () => {
  const { login, authenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect URL from location state or default to home
  const from = location.state?.from?.pathname || '/';

  // Automatically redirect to Keycloak SSO on component mount
  useEffect(() => {
    if (!authenticated && !loading) {
      console.log('Auto-redirecting to Keycloak SSO with callback URL:', from);
      try {
        // Pass the callback URL to Keycloak for redirect after authentication
        login(from);
      } catch (error) {
        console.error('Error during automatic login redirect:', error);
      }
    }
  }, [authenticated, loading, login, from]);

  // Redirect to previous page after successful login
  useEffect(() => {
    if (authenticated && !loading) {
      navigate(from, { replace: true });
    }
  }, [authenticated, loading, navigate, from]);

  return (
    <div className="page-container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Redirecting to Login</h2>
        </div>
        <div className="card-content">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
          <p style={{ textAlign: 'center', marginTop: '20px' }}>
            Redirecting to Keycloak authentication...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;